import React from "react";
import { Alert, Typography, Divider } from "@mui/material";

export default function DataGridInfoAlert({ title }) {
  return (
    <Alert severity="info" variant="outlined" sx={{ mb: 4 }}>
      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Create, edit, or delete records.
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        Quick actions:
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        <strong>Click</strong> any cell to edit it directly. You may edit
        multiple rows at once. Edited rows will highlight in yellow and require
        you to <strong>Save</strong> or <strong>Cancel</strong> changes
        individually.
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Use the toolbar to <strong>Add Record</strong> or{" "}
        <strong>Export Data</strong>.
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ fontStyle: "italic" }}>
        If you encounter any issues or have questions, please reach out to{" "}
        <strong>LRE Water</strong> for assistance.
      </Typography>
    </Alert>
  );
}
